import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class DocDuLieuDCUService {

  public listDienLuc: any = Array();
  public listData: any = [];
  APIURL = "api/SendByteTCP/DTT";
  constructor(public api: ApiService) {
  }
  
  docDCU(mataikhoan, danhmucid, thoiDiem,sotrang,sodong) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.P_LAY_TT_DOC_DCU"}',
      "para": '{"v_mataikhoan":"' + mataikhoan + '","v_danhmucid":"' + danhmucid + '","v_date":"' + thoiDiem + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);

  }

  docDCUQuaKhu(lstMeterID, thoiDiem) {
    var param = {
      "config": '{"namesql":"PKG_THONGSOVANHANH.P_LAY_DULIEU_DCUQUAKHU"}',
      "para": '{"v_lst_meterid":"' + lstMeterID + '","v_day":"' + thoiDiem + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);

  }

  guiLenhDocQuaKhuDCU(randomKey)
  {
    var param = {
      "config": '{"namesql":"PKG_THONGSOVANHANH.P_GUI_LENH_DOC_QUA_KHU"}',
      "para": '{"v_key":"' + randomKey + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  insertBT(lenh,tableName)
  {
    var param = {
      "table": lenh,
      "des_table": tableName
    };
    return this.api.Excute("api/BulkcopyOracle", param);
  }

  docDCU_EXCEL(user, danhmucid: number,ngay: string, tenDanhmuc: string, socongto:string, socongto1:string,filename: string) {
    let cols = [];
    cols = [
      { "name": "row_number", "label": "STT", "horizontalalignment": "center" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "pgiaotong", "label": "Chỉ số (KWh)", "horizontalalignment": "right" },
      { "name": "time", "label": "Thời gian đọc", "horizontalalignment": "center" },
      { "name": "status", "label": "Trạng thái đọc", "horizontalalignment": "left" },
    ]

    //let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_DOCTUCTHOI.P_LAY_TT_DOC_DCU_EXCEL" }),
      para: JSON.stringify({
        v_mataikhoan: user,
        v_danhmucid:danhmucid,
        v_meterid: socongto,
        v_meterid1: socongto1,
        v_date: ngay
      }),
      title: "ĐỌC DỮ LIỆU TỪ DCU",
      header: "Trạm: " + tenDanhmuc+" - Ngày: " + ngay,
      filename: filename,
      sheets: 'Đọc dữ liệu từ DCU',
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
  layDanhSachKH(danhmucid,sotrang,sodong) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.LAYKHACHHANG_TUIMEI"}',
      "para": '{"v_imei":"' + danhmucid +'","v_sotrang":"' + sotrang +'","v_sodong":"' + sodong +'"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  docDCUDetail(imei,thoidiem) {
    var param = {
      "config": '{"namesql":"PKG_DOCTUCTHOI.LAYTHONGSO_DCU_DETAIL"}',
      "para": '{"v_imei":"' + imei +'","v_date":"' + thoidiem +'"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/giam-sat/doc-du-lieu-dcu/docdulieudcu.service.ts